'use client'
import React, { useState, useEffect } from 'react'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import Image from 'next/image'

import ContactSection from '../../../app/_components/Section/Contact'
import servicesData from '../../../app/_utilities/data/sections/services.json'
import PageBanner from '../PageBanner'
const ServicesSlider = dynamic(() => import('../../../app/_components/Sliders/ServicesSlider'), {
  ssr: false,
})

const Service1: React.FC = () => {
  const [showFullTexts, setShowFullTexts] = useState(
    Array(servicesData.services.length).fill(false),
  )
  const [custome, setCustome] = useState<number>(0);

  useEffect(() => {
    const handleResize = (): void => {
      const width = window.innerWidth;
      setCustome(width);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const handleToggleText = (index: number) => {
    const newShowFullTexts = [...showFullTexts]
    newShowFullTexts[index] = !newShowFullTexts[index]
    setShowFullTexts(newShowFullTexts)
  }

  const handleTitleClick = (text: string) => {
    const element = document.getElementById(`${text}`)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <>
      <Head>
        <title>Services - Pyther Innovation</title>
        {/* <link rel="canonical" href={`${process.env.NEXT_PUBLIC_SERVER_URL}/services`} /> */}
      </Head>
      <PageBanner pageName={'Services'} pageTitle={'SaaS development services'} />

      {/* We Provides Service Section */}
      <section className="mil-p-0-10">
        <div className="container mt-4">
          <div className="mil-text-center mil-mb-40">
            <h2 className="mil-h2 mil-font fnt-s"><p style={{marginBottom:'0'}}>Explore Our <span className='activ-color'>Comprehensive IT Services: </span> </p><p style={{marginBottom:'0'}}> Tailored Solutions for Your  <span className='activ-color'>Business Needs</span></p></h2>
          </div>
          <div className="row" style={{ marginLeft: 0 }}>
            {servicesData.services.map((service, index) => {
              const nextServiceIndex = (index + 1) % servicesData.services.length
              const nextService = servicesData.services[nextServiceIndex]
              // Determine whether it's the last service
              const isLastService = index === servicesData.services.length - 1

              return (
                <div
                  className={`row ${
                    index % 2 === 0 ? 'flex-sm-row-reverse' : ''
                  } align-items-center div-hover`}
                  key={index} id={isLastService ? '' : nextService.link}
                >
                  <div className="col-xl-6" style={{ textAlign: 'center' }}>
                    {/* Set the id attribute to the link of the next service */}
                    <a id={isLastService ? '' : nextService.link} href='/' aria-label={isLastService ? 'Last Service' : 'Next Service'}/>
                    <Image
                      src={service?.image}
                      alt={service.title}
                      className="service-img"
                      width={600}
                      height={200}
                      style={{maxHeight: `${service?.height}`, marginBottom: `${custome <= 1200 ? '0': service?.mb}`}}
                    />
                  </div>
                  <div className="col-xl-5 ">
                    <h3
                      className=" mil-h3" style={{ marginTop:'13px' }}
                      >
                      {service.title}
                    </h3>
                    <p className="mil-mb-30 mil-dig-text" style={{ textAlign: 'justify' }}>
                      {showFullTexts[index]
                        ? service.description
                        : `${service.description.slice(0, 350)}...`}
                      <span
                        style={{ color: '#f57c00', cursor: 'pointer' }}
                        onClick={() => handleToggleText(index)}
                      >
                        {showFullTexts[index] ? ' Read Less' : ' Read More'}
                      </span>
                    </p>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </section>

      {/* Our area section */}
      <ServicesSlider />
      <ContactSection />
    </>
  )
}

export default Service1
